<template>
  <div class="total-detailed-container">
    <div
      v-if="totalInitiators > 0"
      class="total-block"
    >
      <div
        data-testid="initiators-title"
        class="block-title gordita-500-14-m"
      >
        {{ $t('license.totalDetailedView.initiators') }}
      </div>
      <div
        data-testid="initiators-amount"
        class="total-amount sans-700-22"
      >
        {{ totalInitiators }}
      </div>
      <div class="total-detailed">
        <div
          v-if="license?.windows?.summary?.totalFixedInitiators > 0"
          class="total-detailed-row"
        >
          <q-icon
            data-testid="initiators-details-fixed-icon"
            class="incredicon-fixed total-detailed-icon"
          />
          <div
            data-testid="initiators-details-fixed-text"
            class="gordita-regular-14 total-row-item"
          >
            Fixed
          </div>
          <div
            v-if="license?.windows?.summary?.totalFloatingInitiators > 0"
            class="sans-700-15"
            data-testid="initiators-details-fixed-total"
          >
            {{ license?.windows?.summary?.totalFixedInitiators }}
          </div>
        </div>
        <div
          v-if="license?.windows?.summary?.totalFloatingInitiators > 0"
          class="total-detailed-row floating-container"
        >
          <q-icon
            data-testid="initiators-details-floating-icon"
            class="incredicon-floating total-detailed-icon"
          />
          <div
            data-testid="initiators-details-floating-text"
            class="gordita-regular-14 total-row-item"
          >
            Floating
          </div>
          <div
            v-if="license?.windows?.summary?.totalFixedInitiators > 0"
            class="sans-700-15"
            data-testid="initiators-details-floating-total"
          >
            {{ license?.windows?.summary?.totalFloatingInitiators }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="totalCIInitiators > 0"
      class="total-block"
    >
      <div
        data-testid="ci-initiators-title"
        class="block-title gordita-500-14-m"
      >
        {{ $t('license.totalDetailedView.ciInitiators') }}
      </div>
      <div
        data-testid="ci-initiators-amount"
        class="total-amount sans-700-22"
      >
        {{ totalCIInitiators }}
      </div>
      <div class="total-detailed">
        <div
          v-if="license?.windows?.summary?.totalFixedCIInitiators > 0"
          class="total-detailed-row"
        >
          <q-icon
            data-testid="ci-initiators-details-fixed-icon"
            class="incredicon-fixed total-detailed-icon"
          />
          <div
            data-testid="ci-initiators-details-fixed-text"
            class="gordita-regular-14 total-row-item"
          >
            Fixed
          </div>
          <div
            v-if="license?.windows?.summary?.totalFloatingCIInitiators > 0"
            class="sans-700-15"
            data-testid="ci-initiators-details-fixed-total"
          >
            {{ license?.windows?.summary?.totalFixedCIInitiators }}
          </div>
        </div>
        <div
          v-if="license?.windows?.summary?.totalFloatingCIInitiators > 0"
          class="total-detailed-row floating-container"
        >
          <q-icon
            data-testid="ci-initiators-details-floating-icon"
            class="incredicon-floating total-detailed-icon"
          />
          <div
            data-testid="ci-initiators-details-floating-text"
            class="gordita-regular-14 total-row-item"
          >
            Floating
          </div>
          <div
            v-if="license?.windows?.summary?.totalFixedCIInitiators > 0"
            class="sans-700-15"
            data-testid="ci-initiators-details-floating-total"
          >
            {{ license?.windows?.summary?.totalFloatingCIInitiators }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="buildCache > 0"
      class="total-block"
    >
      <div
        data-testid="build-cache-title"
        class="block-title gordita-500-14-m"
      >
        {{ $t('license.totalDetailedView.buildCache') }}
      </div>
      <div
        data-testid="build-cache-amount"
        :class="`total-${unlimitedCacheCores ? 'unlimited' : 'amount'} sans-700-${unlimitedCacheCores ? '23' : '22'}`"
      >
        {{ unlimitedCacheCores ? 'Unlimited' : buildCache }}
      </div>
    </div>
    <div
      v-if="totalHelperCores > 0"
      class="total-block"
    >
      <div
        data-testid="helper-cores-title"
        class="block-title gordita-500-14-m"
      >
        <div class="flex items-center justify-center">
          <div
            v-if="showSCLSection"
            class="mr-[2px]"
          >
            <i class="incredicon-solid-windows !text-[16px] text-Text/text_medium" />
            <i class="uil uil-linux !text-[16px] text-Text/text_medium" />
          </div>
          <div>{{ $t('license.totalDetailedView.helperCores') }}</div>
        </div>
      </div>
      <div
        data-testid="helper-cores-amount"
        :class="`total-${unlimitedHelperCores ? 'unlimited' : 'amount'} sans-700-${unlimitedHelperCores ? '23' : '22'}`"
      >
        {{ unlimitedHelperCores ? 'Unlimited' : totalHelperCores }}
      </div>
      <div
        v-if="!unlimitedHelperCores"
        class="total-detailed"
      >
        <div
          v-if="license?.windows?.summary?.totalFixedCores > 0"
          class="total-detailed-row"
        >
          <q-icon
            data-testid="fixed-helper-cores-icon"
            class="incredicon-fixed total-detailed-icon"
          />
          <div
            data-testid="fixed-helper-cores-text"
            class="gordita-regular-14 total-row-item"
          >
            Fixed
          </div>
          <div
            v-if="license?.windows?.summary?.totalFloatingCores > 0"
            class="sans-700-15"
            data-testid="fixed-helper-cores-total"
          >
            {{ license?.windows?.summary?.totalFixedCores }}
          </div>
        </div>
        <div
          v-if="license?.windows?.summary?.totalFloatingCores > 0"
          class="total-detailed-row floating-container"
        >
          <q-icon
            data-testid="floating-helper-cores-icon"
            class="incredicon-floating total-detailed-icon"
          />
          <div
            data-testid="floating-helper-cores-text"
            class="gordita-regular-14 total-row-item"
          >
            Floating
          </div>
          <div
            v-if="license?.windows?.summary?.totalFixedCores > 0"
            class="sans-700-15"
            data-testid="floating-helper-cores-total"
          >
            {{ license?.windows?.summary?.totalFloatingCores }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useLicensePageQuery } from '@/graphql/codegen/generated/graphql';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { Constants } from '@/const/globals';

export default defineComponent({
  name: 'LicenseTotalDetailedView',
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);

    const GQL_useLicenseInfoQuery = useLicensePageQuery(() => ({
      coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
    }));
    return { GQL_useLicenseInfoQuery };
  },
  computed: {
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license || {};
    },
    showSCLSection() {
      return this.license?.windows?.features?.productFeatures?.includes(Constants.LICENSE_FEATURES.SCL) && this.size !== 'small';
    },
    totalInitiators() {
      return (this.license?.windows?.summary?.totalFloatingInitiators || 0) + (this.license?.windows?.summary?.totalFixedInitiators || 0);
    },
    totalCIInitiators() {
      return (this.license?.windows?.summary?.totalFloatingCIInitiators || 0) + (this.license?.windows?.summary?.totalFixedCIInitiators || 0);
    },
    buildCache() {
      return this.license?.windows?.summary?.totalBuildCacheCores || 0;
    },
    totalHelperCores() {
      return (this.license?.windows?.summary?.totalFloatingCores || 0) + (this.license?.windows?.summary?.totalFixedCores || 0);
    },
    unlimitedHelperCores() {
      return this.license?.windows?.summary?.unlimitedHelperCores;
    },
    unlimitedCacheCores() {
      return this.license?.windows?.summary?.unlimitedCacheCores;
    },
  },
});
</script>

<style lang="scss" scoped>
.total-detailed-container {
  flex-wrap: nowrap;
  display: flex;
  align-items: center;
  color: $-text--dark;

  .total-block {
    height: 148px;
    min-width: 230px;
    border-right: 1px solid $-system-app-border;
    text-align: center;
    flex-grow: 1;

    .total-detailed-icon {
      font-size: 22px;
      padding-right: 13px;
      color: $-text-text-primary;
    }

    .total-amount {
      padding-top: 12px;
    }

    .total-unlimited {
      padding-top: 13px;
    }

    .total-detailed {
      padding-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .total-row-item {
        width: 64px;
        text-align: left;
      }

      .total-detailed-row {
        display: flex;

        &:nth-child(2) {
          padding-top: 13px;
        }
      }
    }

    &:last-child {
      border-right: initial;
    }
  }
}
</style>
